import { DropdownColumnFilterValue } from "src/app/core/table";

/** The managed type on a purchase order. */
export enum ManagedTypeEnum {
  /** Type T - Over the Road/Carrier or Vendor Managed */
  TruckLoad = "T",
  /** Type B - Partner Managed */
  Backhaul = "B",
  /** Type L - Partner Managed/Contract */
  Logistics = "L",
  /** Type C - Contract or Consolidated */
  Contract = "C",
}

export interface ManagedTypeOption extends DropdownColumnFilterValue {
  readonly id: ManagedTypeEnum;
  readonly name: string;
}

export const ManagedTypeOptions: readonly ManagedTypeOption[] = [
  { id: ManagedTypeEnum.TruckLoad, name: "Truck Load (T)" },
  { id: ManagedTypeEnum.Backhaul, name: "Backhaul (B)" },
  { id: ManagedTypeEnum.Logistics, name: "Logistics (L)" },
  { id: ManagedTypeEnum.Contract, name: "Contract (C)" },
];

/** The type of drop load appointments allowed by a reservation. */
export enum DropLoadAvailabilityEnum {
  Mandatory = "Required",
  NotAllowed = "Disallowed",
  Optional = "Optional",
}

/** The order status on a purchase order */
export enum OrderStatusEnum {
  Active = "Active",
  Cancelled = "Cancelled",
}

export const orderStatusDisplayLookup: Readonly<
  Record<OrderStatusEnum, string>
> = {
  [OrderStatusEnum.Active]: "Active",
  [OrderStatusEnum.Cancelled]: "Cancelled",
};

export enum PartnerAvailabilityStatusEnum {
  Live = "Active",
  Pending = "Pending",
  Decommissioned = "Inactive",
}

export const PartnerStatusOptions: readonly DropdownColumnFilterValue[] = [
  { id: PartnerAvailabilityStatusEnum.Live, name: "Live" },
  { id: PartnerAvailabilityStatusEnum.Pending, name: "Pending" },
  { id: PartnerAvailabilityStatusEnum.Decommissioned, name: "Decommissioned" },
];

export enum SiteAvailabilityStatusEnum {
  Live = "Active",
  LivePartnerOnly = "LivePartnerOnly",
  Pending = "Pending",
  Decommissioned = "Inactive",
}

export enum FuelLevelEnum {
  Empty = "Empty",
  FiveEighths = "5/8",
  Full = "Full",
  OneEighth = "1/8",
  OneFourth = "1/4",
  OneHalf = "1/2",
  SevenEighths = "7/8",
  ThreeEighths = "3/8",
  ThreeFourths = "3/4",
}

export const ValidationConstants = {
  companyMax: 100,
  companyMin: 0,
  driverCDLMaxLength: 25,
  driverNameMaxLength: 51,
  loadWeightMin: 0,
  sealNumberMax: 250,
  sealNumberMin: 0,
  tractorNumberMax: 100,
  tractorNumberMin: 0,
  shipmentNumberMax: 100,
  trailerMaxLength: 50,
  trailerTemperatureMax: 999,
  trailerTemperatureMin: -999,
  trailerTemperatureStep: 1,
} as const;

export const RefetchDelayInMilliseconds = 1000;
